<template>
  <div class="formCom">
    <div class="form" v-click-outside="closeModal">
      <button class="close" @click="closeModal">
        <CloseIcone></CloseIcone>
      </button>
      <Dot
        :title="'Edit Test Kit'"
        :activeStep="currentFormPart"
        @active="active"
      ></Dot>
      <div class="com" v-show="currentFormPart == 0">
        <div class="input-wrap disabledinput">
          <input
            type="text"
            class="input toUppercase fade-input"
            name="kit_dashboard"
            placeholder="Kit ID"
            v-model="kit_id"
            :class="{ invalid: errors.has('kit') }"
            v-mask="'XX - XX - XXX - XXXX'"
            v-validate="{ required: true, length: 20 }"
            :disabled=true  
          />
          <span class="validate-error" v-if="errors.has('kit_dashboard')">
            {{ errors.first("kit_dashboard") }}
          </span>
        </div>
        <div class="input-wrap disabledinput">
          <input
            type="text"
            class="input fade-input"
            placeholder="Number Of Rooms"
            v-model="indoor_samples"
            maxlength="1"
            name="rooms"
            :disabled=true
            v-validate="'required|numeric|max_value:3'"
          />
          <span class="validate-error" v-if="errors.has('rooms')">{{
            errors.first("rooms")
          }}</span>
        </div>
        <div class="input-wrap title_radio sub-filter" >
              <span class="radio-span">
                <input type="radio" name="paymentMethod" value=1 v-model="paymentMethod" v-validate="'required|paymentMethodNotEmpty'">Paid
              </span>
              <span class="radio-span">
                <input type="radio" name="paymentMethod" value=0 v-model="paymentMethod" v-validate="'required|paymentMethodNotEmpty'">Promo
              </span>
              <span class="validate-error" v-if="errors.has('paymentMethod')">{{
                errors.first("paymentMethod")
              }}</span>
        </div>
      </div>
      <div class="com"  v-show="currentFormPart == 1">
        <div class="inputs-wrap small">
          <div class="input-wrap">
            <div class="datepickerWrapDiv">
              <Datepicker
                placeholder="Expiration Date"
                class="custom-datepicker"
                v-model="expiration_date"
                :format="formatDate"
                 minimum-view = 'month'
                :disabled-dates="{ to: new Date() }"
                :calendar-class="{ calendarWrap: true }"
                :class="{ datepickerWrapAdmin: true }"
                :input-class="{ datepickerInputAdmins: true }"
              ></Datepicker>
              <img
                src="../../../images/dashboard/calendar.png"
                alt="#"
                class="datepickerWrapDiv-img"
              />
              <button
                class="datepickerWrapDiv-img-cross"
                v-if="expiration_date !== null"
                @click="expiration_date = null"
              >
              </button>
            </div>
          </div>
        </div>
        <div class="input-wrap">
          <input
                type="number"
                class="input no-arrows"
                maxlength="5"
                placeholder="Order Number"
                v-model="OrderNumber"
                oninput="this.value = this.value.slice(0, 5)" 
          />
        </div>
        <div class="input-wrap">
          <input
            type="text"
            class="input toLowerCase"
            placeholder="Email"
            name="collected_email"
            v-validate="'email'"
            :class="{ invalid: errors.has('collected_email') }"
            v-model="collectedEmail"
          />
          <span class="validate-error" v-if="errors.has('collected_email')">
              {{errors.first("collected_email")}} 
          </span>
        </div>
        <div class="input-wrap">
          <input
            type="text"
            class="input toUppercase"
            placeholder="Shipping Method"
            v-model="shipMethod"
          />
        </div>
        <div class="input-wrap">
          <input
                type="number"
                class="input no-arrows"
                placeholder="Tracking Number"
                v-model="trackNumber"
          />
        </div>
        <div class="input-wrap">
          <input
                type="number"
                class="input no-arrows"
                placeholder="Pump SN"
                v-model="pumpSn"
          />
        </div>
      </div>
      <div v-show="currentFormPart == 0">
        <button
          class="btn"
          @click.prevent="$validator.validateAll()"
          @click="next"
        >
          Continue
        </button> 
      </div>
      <div v-show="currentFormPart == 1">
          <div class="d-flex">
              <button
                class="btn-back"
                @click="back"
              >
                Back
              </button>
              <button
                class="btn"
                @click.prevent="$validator.validateAll()"
                @click="addKit"
              >
                Save
              </button>
          </div>
	      <div class="txt">{{ txt }}</div>     
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
import { mask } from "vue-the-mask";
import { parseAndConvertKitId } from "../../mixins/parseAndConvertKitId";
import CloseIcone from "../../../images/shared/cancel";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import Dot from "./../addKit/Dot";

export default {
  name: "EditTestkit",
  mixins: [parseAndConvertKitId],
  directives: { mask },
  data() {
    return {
      kit_id: null,
      indoor_samples: null,
      paymentMethod:null,
      OrderNumber:null,
      shipMethod:null,
      trackNumber:null,
      collectedEmail:null,
      id:null,
      txt:null,
      pumpSn:null,
      expiration_date:null,
      currentFormPart:0
    };
  },
  components: {
    CloseIcone,
    Datepicker,
    Dot
  },
  methods: {
    ...mapActions(["editTestKit", "sendSearchReq"]),
    ...mapMutations(["clearServerValidationErrors"]),
    next(){
      if (this.errors.any() || !this.isComplete) {
        return;
      }
      this.currentFormPart = 1;
    },
    back(){
      this.currentFormPart = 0;
    },
    addKit() {
      if (this.errors.any() || !this.isComplete) {
        return;
      }
      const data = {
        id: this.id,
        indoor_samples: this.indoor_samples,
        price_type: this.paymentMethod,
        order_number: this.OrderNumber,
        collected_email: this.collectedEmail,
        ship_method:this.shipMethod,
        track_number:this.trackNumber,
        pump_sn:this.pumpSn,
        expiration_at : this.expiration_date != null ? moment(this.expiration_date).format() : null
      };
      this.editTestKit(data).then(res => {
        this.txt = "Teskit successfully Updated";
        this.errors.clear();
        this.clearServerValidationErrors();
        this.sendSearchReq();
        // setTimeout(res => {
        //     this.closeModal();
        // }, 5000);
      
      });
    },
    closeModal() {
      this.errors.clear();
      this.clearServerValidationErrors();
      this.$emit("closeModal", false);
    },
    formatDate(date) {
        return moment(date).format("MMM/YYYY");
    },
    active(val){
      if (this.errors.any() || !this.isComplete) {
        return;
      }
      this.currentFormPart = val;
    },
    disablePastDates(date) {
      // Disable dates earlier than the current date
      return moment(date).isBefore(moment(), 'day');
    }
  },
  computed: {
    isComplete() {
      return this.kit_id && this.indoor_samples && this.paymentMethod;
    },
    ...mapGetters(["serverValidation","getTestKitInfo"])
  },
  watch: {
    serverValidation(error) {
      error.forEach(item => {
        this.$validator.errors.add({ field: item.field, msg: item.message });
      });
    },
    getTestKitInfo(obj) {
      this.kit_id = obj.kit_id;
      this.indoor_samples = obj.indoorSamples.length;
      if(obj.price_type == 1){
        this.paymentMethod = 1;
      } else {
        this.paymentMethod = 0;
      }
      
      this.OrderNumber = obj.order_number;
      this.collectedEmail = obj.collected_email;
      this.shipMethod = obj.ship_method;
      this.trackNumber = obj.track_number;
      this.id = obj.id;
      this.pumpSn = obj.getTestKitInfo.pump_sn;
      if(obj.getTestKitInfo.expiration_at != null) {
        this.expiration_date = obj.getTestKitInfo.expiration_at;
      }
    },
  },
  async mounted() {
    if(typeof this.$store.getters.getTestKitInfo != 'undefined') {
      this.kit_id = this.$store.getters.getTestKitInfo.kit_id;
      this.id = this.$store.getters.getTestKitInfo.id;
      this.indoor_samples = this.$store.getters.getTestKitInfo.indoorSamples.length;
      if(this.$store.getters.getTestKitInfo.price_type == 1){
        this.paymentMethod = 1;
      } else {
        this.paymentMethod = 0;
      }
      this.OrderNumber = this.$store.getters.getTestKitInfo.order_number;
      this.collectedEmail = this.$store.getters.getTestKitInfo.collected_email;
      this.shipMethod = this.$store.getters.getTestKitInfo.ship_method;
      this.trackNumber = this.$store.getters.getTestKitInfo.track_number;
      this.pumpSn = this.$store.getters.getTestKitInfo.pump_sn;
      if(this.$store.getters.getTestKitInfo.expiration_at != null) {
       this.expiration_date = this.$store.getters.getTestKitInfo.expiration_at;
      }
    }
  }
};
</script>

<style scoped>
.disabledinput {
  background-color: #e3dfdf;
}

.d-flex {
    display: flex;
}
.d-flex button {
      margin-right: 10px; /* Adjust margin as needed */
}
.close {
  position: absolute;
  right: 15px;
  top: 15px;
  border: 1px solid transparent;
  cursor: pointer;
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background-color: transparent;
}
.formCom {
  background-color: rgba(219, 230, 241, 0.5);
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  top: 0;
  z-index: 99;
}
.input.invalid {
  border: 1px solid red;
}
.form {
  padding: 25px;
  background-color: #fff;
  max-width: 397px;
  width: 100%;
  position: relative;
  z-index: 1;
}
.input-wrap {
  width: 100%;
  margin: 0 0 30px 0;
}
.input {
  border: 1px solid #e4e4e4;
  border-radius: 2px;
  padding: 15px 20px !important;
  color: #4d4d4d !important;
  width: 100% !important;
  font-size: 14px !important;
  font-family: TTNormsLight, sans-serif !important;
  text-align: center !important;
  outline: none !important;
}
.input::placeholder {
  color: #98a4ae;
  font-size: 14px;
  text-transform: capitalize;
  font-family: TTNormsLight, sans-serif;
}
.validate-error {
  bottom: -23px;
}
.toUppercase {
  text-transform: uppercase;
}
.btn {
  background-color: #6cc24a;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  cursor: pointer;
  outline: none;
  border: 1px solid transparent;
  height: 45px;
  border-radius: 25px;
  font-size: 18px;
  transition: all 0.5s linear;
  font-family: TTNormsMedium, sans-serif;
}
.btn.change {
  height: auto;
  width: auto;
  margin: 10px auto 0 auto;
  border-radius: 0px;
  padding: 0;
  color: #6cc24a;
  background-color: transparent;
}
.btn:disabled {
  cursor: default;
  background-color: rgba(108, 194, 74, 0.2);
  color: #6cc24a;
}
.btn:hover:enabled {
  background-color: transparent;
  color: #6cc24a;
  border: 1px solid #6cc24a;
}
.btn.change:hover:enabled {
  background-color: transparent;
  color: #6cc24a;
  border: 1px solid transparent;
}
.btn.change {
  height: auto;
  width: auto;
  margin: 10px auto 0 auto;
  border-radius: 0px;
  padding: 0;
  color: #6cc24a;
  background-color: transparent;
}
.btn:disabled {
  cursor: default;
  background-color: rgba(108, 194, 74, 0.2);
  color: #6cc24a;
}
.btn:hover:enabled {
  background-color: transparent;
  color: #6cc24a;
  border: 1px solid #6cc24a;
}
.btn.change:hover:enabled {
  background-color: transparent;
  color: #6cc24a;
  border: 1px solid transparent;
}
.btn-back {
  background-color: #005eb8;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  cursor: pointer;
  outline: none;
  border: 1px solid transparent;
  height: 45px;
  border-radius: 25px;
  font-size: 18px;
  transition: all 0.5s linear;
  font-family: TTNormsMedium, sans-serif;
}
.btn-back.change {
  height: auto;
  width: auto;
  margin: 10px auto 0 auto;
  border-radius: 0px;
  padding: 0;
  color: #005eb8;
  background-color: transparent;
}
.btn-back:disabled {
  cursor: default;
  background-color: rgba(108, 194, 74, 0.2);
  color: #005eb8;
}
.btn-back:hover:enabled {
  background-color: transparent;
  color: #005eb8;
  border: 1px solid #005eb8;
}
.btn-back.change:hover:enabled {
  background-color: transparent;
  color: #005eb8;
  border: 1px solid transparent;
}
.name {
  color: #005eb8;
  font-size: 24px;
  margin: 0 0 30px 0;
  text-align: center;
  font-family: TTNormsMedium, sans-serif;
}
.title_radio {
  color: #005eb8;
  font-size: 15px;
  font-family: TTNormsMedium, sans-serif;
  width: 100%;
  justify-content: space-between;
  cursor: pointer;
  text-align: center;
  
}
.advance-label{
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
  color: #005eb8;
  margin-top: 36px;
  margin: 0 0 30px 0;
}

.input-title {
  color: #373737;
  padding: 6px 0 11px 0;
  display: block;
  text-align: center;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
  width: 100%;
  outline: none;
}

.container {
  display: flex;
  justify-content: center; /* Optional: Center the content horizontally */
}

.flex-container {
  display: flex;
}

.box {
  margin: 10px;
  padding: 20px;
  border: 1px solid #ccc;
}

.title-down {
  height: 18px;
  cursor: pointer;
  vertical-align: top;
  padding-left: 10px;
}

.rotated {
  transform: scaleY(-1);
  transition: transform 0.3s ease; /* Add a smooth transition effect */
}
.txt{
  color: green;
  font-size: 14px;
  text-align: center;
  font-family: TTNormsLight, sans-serif;
  padding-top: 10px;
}
.fade-out{
  transition: opacity 0.5s ease-in-out;
}

.fade-out:disabled{
  opacity:0.5;
}
.no-arrows {
  /* For Firefox */
  -moz-appearance: textfield;

  /* For Chrome, Safari, and Edge */
  appearance: textfield;
}

/* For Chrome */
.no-arrows::-webkit-inner-spin-button,
.no-arrows::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.drop-down-icone {
  position: absolute;
  right: 20px;
  top: 65%;
  height: auto;
  pointer-events: none;
}
.dropDown {
  display: block;
  position: absolute;
  top: 75px;
  left: 0;
  width: 100%;
  z-index: 10;
  border-left: 1px solid #e5e5e5;
  border-right: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
  border-top: 1px solid transparent;
}
.dropDown-item {
  background-color: #fff;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
  cursor: pointer;
  text-align: center;
  color: #4f4e4e;
}
.dropDown-item span {
  display: block;
  width: 100%;
  padding: 10px 0px;
}
.dropDown-item span:hover {
  background-color: #eaeaea;
}
.dropDownInput {
  padding: 10px;
  color: #4d4d4d;
  width: 100%;
  font-size: 14px;
  text-align: center;
  font-family: TTNormsLight, sans-serif;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-bottom: 1px solid transparent;
  border-top: 1px solid #e5e5e5;
}
.dropDownInput::placeholder {
  color: #98a4ae;
}
.datepickerWrapAdmin {
  border: 1px solid #e4e4e4;
  border-radius: 2px;
  color: #4d4d4d !important;
  width: 100% !important;
  font-size: 14px !important;
  font-family: TTNormsLight, sans-serif !important;
  text-align: center !important;
  outline: none !important;
}
.custom-datepicker {
  max-width:none !important;
  margin: 0px;
}

.datepickerInputCustom {
  padding: 10px 30px 9px 30px;
  outline: none;
  border-radius: 3px;
  cursor: pointer;
  border: none;
  font-size: 10px;
} 
.datepickerWrapDiv-img {
  position: absolute;
  left: 18px;
  top: 8px;
  max-width: 18px;
}
.datepickerWrapDiv-img-cross {
  padding: 0;
  cursor: pointer;
  background-color: transparent;
  border: none;
  width: 11px;
  display: flex;
  align-self: center;
  justify-content: center;
  position: absolute;
  right: 10px;
  top: 10px;
  height: 11px;
}
.com{
  margin: 36px 0 0 0;
}
</style>